import {HTMLInputTypeAttribute} from "react";
import {FieldValues, Path, UseFormRegister} from "react-hook-form";
import {useHookFormMask, withMask} from "use-mask-input";

interface IInputMaskStrategyProps<TFieldValues extends FieldValues> {
    name: Path<TFieldValues>;
    type?: HTMLInputTypeAttribute;
    register: UseFormRegister<TFieldValues>;
    strategy?: IInputMaskStrategy;
}

type MaskType = Parameters<typeof withMask>[0];
type MaskOptions = Parameters<typeof withMask>[1];
export type IMaskStrategyConfiguration = MaskOptions & {maskType: MaskType};

export type IInputMaskStrategy = "numeric";

export const useInputMaskStrategy = <TFieldValues extends FieldValues>(props: IInputMaskStrategyProps<TFieldValues>) => {
    if (props.type !== "text" || !props.strategy) {
        // masking was only tested with text inputs
        return props.register(props.name);
    }

    const registerWithMask = useHookFormMask(props.register);
    const strategyConfiguration = props.strategy ? inputMaskStrategies[props.strategy] : null;

    return strategyConfiguration ? registerWithMask(props.name, strategyConfiguration.maskType, strategyConfiguration) : props.register(props.name);
};

const inputMaskStrategies: {[key in IInputMaskStrategy]: IMaskStrategyConfiguration} = {
    numeric: {
        maskType: "numeric",
        groupSeparator: " ",
        radixPoint: ",",
        digits: 0,
        allowMinus: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
        rightAlign: false,
        positionCaretOnClick: "lvp",
        positionCaretOnTab: false,
        numericInput: true,
        inputType: "number",
        showMaskOnHover: false,
        showMaskOnFocus: false
    }
};
import {HTMLInputTypeAttribute} from "react";
import {FieldValues, Path, UseFormRegister} from "react-hook-form";
import {useHookFormMask, withMask} from "use-mask-input";

interface IInputMaskStrategyProps<TFieldValues extends FieldValues> {
    name: Path<TFieldValues>;
    type?: HTMLInputTypeAttribute;
    register: UseFormRegister<TFieldValues>;
    strategy?: IInputMaskStrategy;
}

type MaskType = Parameters<typeof withMask>[0];
type MaskOptions = Parameters<typeof withMask>[1];
export type IMaskStrategyConfiguration = MaskOptions & {maskType: MaskType};

export type IInputMaskStrategy = "numeric";

export const useInputMaskStrategy = <TFieldValues extends FieldValues>(props: IInputMaskStrategyProps<TFieldValues>) => {
    if (props.type !== "text" || !props.strategy) {
        // masking was only tested with text inputs
        return props.register(props.name);
    }

    const registerWithMask = useHookFormMask(props.register);
    const strategyConfiguration = props.strategy ? inputMaskStrategies[props.strategy] : null;

    return strategyConfiguration ? registerWithMask(props.name, strategyConfiguration.maskType, strategyConfiguration) : props.register(props.name);
};

const inputMaskStrategies: {[key in IInputMaskStrategy]: IMaskStrategyConfiguration} = {
    numeric: {
        maskType: "numeric",
        groupSeparator: " ",
        radixPoint: ",",
        digits: 0,
        allowMinus: false,
        autoUnmask: true,
        removeMaskOnSubmit: true,
        rightAlign: false,
        positionCaretOnClick: "lvp",
        positionCaretOnTab: false,
        numericInput: true,
        inputType: "number",
        showMaskOnHover: false,
        showMaskOnFocus: false
    }
};
